import request from '@/utils/request'
export function getRoleByPage(data: any) {
  return request({
    url: 'tasks/sysRole/page',
    method: 'get',
    params: data
  })
}
export function getPageForPC(data: any) {
  return request({
    url: 'tasks/sysUser/pageForPC',
    method: 'get',
    params: data
  })
}
//重置密码
export function resetPassword(data: any) {
  return request({
    url: 'tasks/sysUser/changePwdForPC',
    method: 'post',
    data: data
  })
}

//修改密码
export function updatePassword(data: any) {
  return request({
    url: 'tasks/sysUser/updatePwdForPC',
    method: 'post',
    data: data
  })
}

//删除单个用户
export function deleteSingle(id: number) {
  return request({
    url: 'tasks/sysUser/softDeleteForPC/' + id,
    method: 'post',

  })
}
//批量删除用户
export function deleteArray(data: number[]) {
  return request({
    url: 'tasks/sysUser/batchSoftDeleteForPC',
    method: 'post',
    data: data
  })
}
//更新用户
export function updateForPC(data) {
  return request({
    url: 'tasks/sysUser/updateForPC',
    method: 'post',
    data: data
  })
}
//根据ID查询PC用户
export function getPCUserById(id: number) {
  return request({
    url: 'tasks/sysUser/getPCUserById/' + id,
    method: 'get',

  })
}
//获取战区列表
export function getArea() {
  return request({
    url: 'tasks/templateCheck/getArea',
    method: 'get',
  })
}
//获取角色列表
export function getRoles() {
  return request({
    url: 'tasks/sysRole/listAllRoles',
    method: 'get',
  })
}
//新建用户
export function createPCUser(data) {
  return request({
    url: 'tasks/sysUser/createPCUser',
    method: 'post',
    data: data
  })
}
//更新用户
export function updatePCUser(data) {
  return request({
    url: 'tasks/sysUser/updateForPC',
    method: 'post',
    data: data
  })
}
//删除用户数组
export function deleteUserArray(array:number[]){
  return request({
    url: 'tasks/sysUser/batchSoftDeleteForPC',
    method: 'post',
    data:{ids:array}
  })
}
//新建角色
export function createRole(data) {
  return request({
    url: 'tasks/sysRole/create',
    method: 'post',
    data: data
  })
}
//删除单个角色
export function deleteSingleRole(id:number){
  return request({
    url: 'tasks/sysRole/softDelete/' + id,
    method: 'post',

  })
}
//删除角色数组
export function deleteRoleArray(array:number[]){
  return request({
    url: 'tasks/sysRole/batchSoftDelete',
    method: 'post',
    data:{ids:array}
  })
}
//获取菜单信息
export function getMenuList(){
  return request({
    url: 'tasks/sysMenu/listAllMenus',
    method: 'get',

  })
}
//更新建角色
export function updateRole(data) {
  return request({
    url: 'tasks/sysRole/update',
    method: 'post',
    data: data
  })
}
//根据ID查询详情
export function querydetailsById(id:number){
  return request({
    url: 'tasks/sysRole/queryById/' + id,
    method: 'get',

  })
}
//获取当前用户菜单权限
export function getUserMenu() {
  return request({
    url: 'tasks/sysUser/getCurrentUser',
    method: 'get',
  })
}
